/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/365-subscript2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M3.032 13l.9-3h4.137l.9 3h1.775l-3-10H4.256l-3 10h1.776zm2.4-8h1.137l.9 3H4.532l.9-3zM16 3l-2.5 4L11 3h5zM13.5 13h-1a.5.5 0 010-1h2a.5.5 0 000-1h-2a1.502 1.502 0 00-1.117 2.5c.275.307.674.5 1.117.5h1a.5.5 0 010 1h-2a.5.5 0 000 1h2a1.502 1.502 0 001.117-2.5A1.496 1.496 0 0013.5 13z"/>'
  }
})
